import { createSlice } from "@reduxjs/toolkit"
import { getAllServices, getServiceById, getServicesFillDetailsData, servicesDocDelete, servicesDocUpload } from "./servicesActions"
import { getPropertyData, getPropertyOnlyDocsData } from "../property/propertyActions"


const initialState = {
   loading: false,
   allServices: [],
   singleService: [],
   selectedPropertyId: "",
   selectedPropertyData: {},
   fillDetailsData: {},
   uploadedDocs: [],
   error: null,
   message: null,
   success: null,
}

const servicesSlice = createSlice({
   name: 'servicesSlice',
   initialState,
   reducers: {
      setServicesSelectedPropertyId: (state, { payload }) => {
         state.selectedPropertyId = payload
      },
      clearSelectedPropertyIdAndData: (state) => {
         state.selectedPropertyId = ""
         state.selectedPropertyData = {}
      },
      clearServicesFillDetailsData: (state) => {
         state.fillDetailsData = {}
      },
      setServices:(state,{payload })=>{
         state.allServices = payload
      }


   },
   extraReducers: (builder) => {
      // get Services
      builder.addCase(getAllServices.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getAllServices.fulfilled, (state, { payload }) => {
         state.loading = false
         // state.allServices = payload?.response?.data
      })
      builder.addCase(getAllServices.rejected, (state, { payload }) => {
         state.loading = false
         state.error = true
      })

      // get Individual Service
      builder.addCase(getServiceById.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getServiceById.fulfilled, (state, { payload }) => {
         state.loading = false
         state.singleService = payload?.response?.data
      })
      builder.addCase(getServiceById.rejected, (state, { payload }) => {
         state.loading = false
         state.error = true
      })

      // get a single property data
      builder.addCase(getPropertyData.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getPropertyData.fulfilled, (state, { payload }) => {
         state.loading = false
         state.selectedPropertyData = payload?.response?.data?.data?.item
      })
      builder.addCase(getPropertyData.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // get Fill Details Data
      builder.addCase(getServicesFillDetailsData.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getServicesFillDetailsData.fulfilled, (state, { payload }) => {
         state.loading = false

         const radio = payload?.response?.data['radio']?.reverse()

         state.fillDetailsData = payload?.response?.data
      })
      builder.addCase(getServicesFillDetailsData.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // Services document upload if not property selected
      builder.addCase(servicesDocUpload.pending, (state) => {
         state.loading = true
      })
      builder.addCase(servicesDocUpload.fulfilled, (state, { payload }) => {
         state.loading = false
         const newData = payload?.response?.data?.data?.item;
         const obj = { id: newData?.form, url: newData?.url }
         state.uploadedDocs = [...state.uploadedDocs, obj];
      })
      builder.addCase(servicesDocUpload.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // Services document delete document delete
      builder.addCase(servicesDocDelete.pending, (state) => {
         state.loading = true
      })
      builder.addCase(servicesDocDelete.fulfilled, (state, { payload }) => {
         state.loading = false
         const id = payload?.id
         const presentDocs = state.uploadedDocs
         const updatedDocs = presentDocs.filter(doc => doc?.id !== id);
         state.uploadedDocs = updatedDocs;
      })
      builder.addCase(servicesDocDelete.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // get uploaded property doc data
      builder.addCase(getPropertyOnlyDocsData.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getPropertyOnlyDocsData.fulfilled, (state, { payload }) => {
         state.loading = false
         state.selectedPropertyData = {
            ...state.selectedPropertyData,
            docs: payload?.response?.data?.data?.item?.docs,
            documents: payload?.response?.data?.data?.item?.docs,
            propertyScore: payload?.response?.data?.data?.item?.propertyScore
         }
      })
      builder.addCase(getPropertyOnlyDocsData.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

   },
})

export default servicesSlice.reducer

export const { setServicesSelectedPropertyId, clearSelectedPropertyIdAndData, clearServicesFillDetailsData,setServices } = servicesSlice.actions